import styles from "./style.module.css";
// import ErrorAlertIcon from "../../assets/alert.svg";
import { AlertIcon } from "../../assets";

const Alert = ({ text, type, style={} }) => {
	return (
		<div
			className={
				type === "success"
					? [styles.alert, styles.success].join(" ")
					: type === "error"
					? [styles.alert, styles.error].join(" ")
					: styles.alert
			}
			style={style}
		>
			{type === "error" && (
				<AlertIcon />
			)}
			{text}
		</div>
	);
};

export default Alert;
